import { push } from 'connected-react-router';
import { isEmpty, every } from 'lodash';

import * as queryString from 'query-string';

import { CoordinateMode } from '../../../models/coordinate.model';
import { FilterItemModel } from '../../../models/filter.model';
import { DetailProductModel, GetProductListModel, ProductModel } from '../../../models/products.model';
import { SetSujetCheckModel, SujetCheckModel } from '../../../models/request.model';
import { updateQueryString, urlToFilters } from '../../../providers/location.provider';
import LocationService from '../../../services/LocationService/LocationService';
import { getCordsMap, getSelectPayloadWithFilters, resetFilterData } from '../../../utils';
import { downloadFile } from '../../../utils/file';
import { getCollection, setCollection } from '../../collection';
import {
    DataSchemeFilter,
    DataSchemeSingleProduct,
    GET_CURRENT_POSITION,
    GET_DATA_FILTER,
    GET_DATA_FROM_URL_PARAMS,
    GET_FACT_SHEET,
    GET_NEIGHBORS_PRODUCTS,
    GET_PRODUCT,
    GET_PRODUCT_DETAILS,
    GET_PRODUCT_LIST,
    getDataFilter,
    getDataFromUrlParams,
    getFactSheet,
    getNeighborsProducts,
    getProduct,
    getProductDetails,
    getProductList,
    RESET_DATA_FILTER,
    SEND_REQUEST,
    sendRequest,
    setCoordinateData,
    setDataFilter,
    setFactSheetPDF,
    setFactSheetXLSX,
    setNeighborsProducts,
    setProductDetails,
    setProductList,
    setProductListWithReset,
    setProducts,
    UPDATE_COORDINATE_DATA,
    UPDATE_DATA_FILTER,
    updateCoordinateData,
    updateDataFilter,
    GET_SMART_PHRASES,
    setSmartPhrases,
    setSmartPhrasesList,
    SmartPhrase,
    GET_SUJETCHECK_IMAGES,
    UPLOAD_SUJETCHECK_IMAGE,
    getSujetcheckImages,
    uploadSujetcheckImage,
} from '../../location';
import {
    ABORT_SEARCH,
    createNewAbortController,
    SET_BOOKING_YEAR,
    setBookingYear,
    setFactSheetPPT,
    setSmartPhrase,
    setSujetcheckImageData,
    setSujetcheckImages,
} from '../../location/actions';
import { MainStore } from '../../store';
import { setError, setLoader, togglePopup } from '../../ui';

let currentProductDetailsPayload: ReturnType<typeof getProductDetails>['payload'] | null = null;
let isProductDetailsLoading = false;

let currentNeighborsProductsPayload: ReturnType<typeof getNeighborsProducts>['payload'] | null = null;
let isNeighborsProductsLoading = false;

const initiateGetProducts = (
    store: MainStore,
    payloadObj: GetProductListModel,
    action: ReturnType<typeof getProductList>
) => {
    const { reset = false } = action.payload;
    const {
        location: { controller, coordinate },
        router: {
            location: { search, query },
        },
    } = store.getState();
    const newCoordinate = {
        individualproduct: undefined,
        latitude: '',
        longitude: '',
        mode: CoordinateMode.Radius,
        name: '',
        radius: 1000,
    };

    if (!query.phrase) {
        LocationService.getProductList(payloadObj, controller)
            .then(data => getCordsMap(data))
            .then(data => store.dispatch(reset ? setProductListWithReset(data) : setProductList(data)))
            .then(() => {
                store.dispatch(
                    getDataFilter({
                        // getDataFilterWithoutCollection({
                        bookingyear: store.getState().location.bookingYear,
                        coordinate,
                        search,
                    })
                );
            })
            .then(() => store.dispatch(setLoader({ location: false })))
            .catch(err => {
                if (err.toString() !== 'AbortError: The user aborted a request.') {
                    store.dispatch(setError({ location: err }));
                    store.dispatch(setLoader({ location: false }));
                }

                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                if (err.status === 400) {
                    store.dispatch(setProductListWithReset({ data: { products: [], count: 0, eod: false, groupcount: 0 } }));
                }
            });
    } else {
        LocationService.getSmartPhrases()
            .then(data => {
                const selectPayload = getSelectPayloadWithFilters(newCoordinate, search, {
                    bookingyear: store.getState().location.bookingYear,
                    offset: payloadObj.offset,
                    limit: payloadObj.limit,
                    sort: payloadObj.sort,
                    group: payloadObj.group,
                });
                store.dispatch(setProductDetails({ data: null } as unknown as DataSchemeSingleProduct));
                const smartPhrasesDetails = data.data;
                const queryName = query.name && decodeURIComponent(query.name).split(/ - (.*)/s)[1];

                let getSmartPhrase;
                if (queryName) {
                    getSmartPhrase = (smartPhrase: string): SmartPhrase =>
                        smartPhrasesDetails.filter(
                            phrase =>
                                phrase.phrase.toLowerCase() === smartPhrase.toLowerCase() &&
                                phrase.showlabel.startsWith(queryName)
                        )[0];
                } else {
                    getSmartPhrase = (smartPhrase: string): SmartPhrase =>
                        smartPhrasesDetails.filter(phrase => phrase.phrase.toLowerCase() === smartPhrase.toLowerCase())[0];
                }

                let phraseFromUrl = decodeURIComponent(query.phrase);
                if (phraseFromUrl.includes(' - ')) {
                    phraseFromUrl = phraseFromUrl.split(' - ')[0];
                }
                const smartPhrase = getSmartPhrase(phraseFromUrl);

                if (smartPhrase) {
                    store.dispatch(setSmartPhrase(smartPhrase));
                    const searchPhraseCriteria = smartPhrase.selectcriteria;
                    for (const searchCriteria of Object.keys(searchPhraseCriteria)) {
                        const searchCriteriaValue = searchPhraseCriteria[searchCriteria];
                        if (Object.keys(selectPayload.criteria).includes(searchCriteria)) {
                            for (const criteria of Object.keys(selectPayload.criteria)) {
                                if (criteria === searchCriteria) {
                                    if (searchCriteria === 'coordinate') {
                                        ((selectPayload.criteria as never)[searchCriteria] as string[]) =
                                            searchCriteriaValue;
                                    } else {
                                        ((selectPayload.criteria as never)[searchCriteria] as string[]).push(
                                            ...searchCriteriaValue
                                        );
                                    }
                                    break;
                                }
                            }
                        } else {
                            ((selectPayload.criteria as never)[searchCriteria] as string[]) =
                                searchCriteriaValue as string[];
                        }
                    }
                    LocationService.getProductList(selectPayload)
                        .then(data => getCordsMap(data))
                        .then(data => store.dispatch(reset ? setProductListWithReset(data) : setProductList(data)))
                        .catch(err => {
                            store.dispatch(setError({ location: err }));

                            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                            if (err.status === 400) {
                                store.dispatch(
                                    setProductListWithReset({ data: { products: [], count: 0, eod: false, groupcount: 0 } })
                                );
                            }
                        })
                        .finally(() => store.dispatch(setLoader({ location: false })));
                } else {
                    console.debug('here', smartPhrasesDetails);
                    console.error("Smart phrases weren't loaded yet or not found.");
                }
            })
            .catch(err => {
                console.error(err);
            });
    }
};

const getProductListHandler = (store: MainStore, action: ReturnType<typeof getProductList>): void => {
    store.dispatch(setLoader({ location: true }));
    store.dispatch(setError({ location: false }));
    if (!store.getState().router.location.pathname.includes('product')) {
        store.dispatch(setProductDetails({ data: null } as unknown as DataSchemeSingleProduct));
    }

    const { payload } = action.payload;
    const {
        location: { coordinate, filter, smartPhrase, bookingYear },
        router: {
            location: { search, query },
        },
    } = store.getState();

    const payloadObj = getSelectPayloadWithFilters(coordinate, search, payload || {});

    payloadObj.bookingyear = store.getState().location.bookingYear;
    if (filter.basket) {
        payloadObj.criteria.basket = filter.basket;
    }
    if (filter.basketreference) {
        payloadObj.criteria.basketreference = filter.basketreference;
    }

    if (every(payloadObj.criteria, isEmpty) && !smartPhrase && !query.phrase) {
        store.dispatch(setProductListWithReset({ data: { products: [], count: 0, eod: false, groupcount: 0 } }));
        store.dispatch(setError({ location: true }));
        store.dispatch(setLoader({ location: false }));

        return;
    }

    store.dispatch(setError({ product: false }));

    if (coordinate.name && coordinate.individualproduct) {
        LocationService.getProduct({ urn: (coordinate.name as string).split(':')[1], bookingyear: bookingYear })
            .then(productData =>
                getCordsMap({
                    ...productData,
                    data: {
                        count: (productData.data as unknown as ProductModel[]).length,
                        eod: false,
                        groupcount: 0,
                        products: productData.data as unknown as ProductModel[],
                    },
                })
            )
            .then(_data => {
                const extraProducturns: string[] = [];
                for (const product of _data.data.products) {
                    extraProducturns.push(product.producturn);
                }
                payloadObj.criteria.individualproducts = extraProducturns;
                initiateGetProducts(store, payloadObj, action);
            })
            .catch(err => store.dispatch(setError({ product: err })));
    } else {
        initiateGetProducts(store, payloadObj, action);
    }
};

const getProductHandler = (store: MainStore, action: ReturnType<typeof getProduct>): void => {
    store.dispatch(setLoader({ product: true }));
    store.dispatch(setError({ product: false }));

    LocationService.getProduct(action.payload)
        .then(data =>
            getCordsMap({
                ...data,
                data: {
                    count: (data.data as unknown as ProductModel[]).length,
                    eod: false,
                    groupcount: 0,
                    products: data.data as unknown as ProductModel[],
                },
            })
        )
        .then(data => store.dispatch(setProducts({ ...data, data: data.data.products })))
        .catch(err => store.dispatch(setError({ product: err })))
        .finally(() => store.dispatch(setLoader({ product: false })));
};

const getProductDetailsHandler = (store: MainStore, action: ReturnType<typeof getProductDetails>): void => {
    // Überprüfen, ob bereits ein Aufruf mit derselben Payload läuft
    if (isProductDetailsLoading && JSON.stringify(action.payload) === JSON.stringify(currentProductDetailsPayload)) {
        console.log('Doppelter getProductDetailsHandler-Aufruf mit gleicher Payload blockiert.');
        return; // Den doppelten Aufruf blockieren
    }

    // Status setzen, dass ein Aufruf läuft, und die aktuelle Payload speichern
    isProductDetailsLoading = true;
    currentProductDetailsPayload = action.payload;

    // Loader und Fehlerstatus setzen
    store.dispatch(setLoader({ product: true }));
    store.dispatch(setError({ product: false }));
    console.log('getProductDetailsHandler', action.payload);

    LocationService.getProductDetails(action.payload)
        .then(data =>
            getCordsMap({
                ...data,
                data: {
                    count: 1,
                    eod: false,
                    groupcount: 0,
                    products: [],
                    product: data.data as unknown as DetailProductModel,
                },
            })
        )
        .then(data => {
            const productDetailData = data.data.product as DetailProductModel; // Extrahieren der Produktdetails

            // Produktdetails zuerst im Store aktualisieren
            store.dispatch(setProductDetails({ ...data, data: productDetailData } as unknown as DataSchemeSingleProduct));

            const currentSearch = store.getState().router.location.search;
            const parsedCurrentSearch = queryString.parse(currentSearch.replace('?', ''));
            const currentUrnInUrl = parsedCurrentSearch.urn as string;
            const newProductUrn = productDetailData.producturn;

            // Prüfen, ob die URL einen 'urn'-Parameter hat und ob sich der producturn geändert hat
            if (currentUrnInUrl && newProductUrn && currentUrnInUrl !== newProductUrn) {
                const updatedSearch = updateQueryString(currentSearch, { urn: newProductUrn });
                store.dispatch(push({ search: updatedSearch }));
            }

            return data; // Daten an nachfolgende .then()-Aufrufe weitergeben
        })
        .catch(err => {
            store.dispatch(setError({ product: err }));
            store.dispatch(setProductDetails({ data: null } as unknown as DataSchemeSingleProduct));
        })
        .finally(() => {
            store.dispatch(setLoader({ product: false }));
            // Status zurücksetzen, sobald der Aufruf abgeschlossen ist (erfolgreich oder mit Fehler)
            isProductDetailsLoading = false;
            currentProductDetailsPayload = null;
        });
};

const getNeighborsProductsHandler = (store: MainStore, action: ReturnType<typeof getNeighborsProducts>): void => {
    // Überprüfen, ob bereits ein Aufruf mit derselben Payload läuft
    if (isNeighborsProductsLoading && JSON.stringify(action.payload) === JSON.stringify(currentNeighborsProductsPayload)) {
        console.log('Doppelter getNeighborsProductsHandler-Aufruf mit gleicher Payload blockiert.');
        return; // Den doppelten Aufruf blockieren
    }

    // Status setzen, dass ein Aufruf läuft, und die aktuelle Payload speichern
    isNeighborsProductsLoading = true;
    currentNeighborsProductsPayload = action.payload;

    store.dispatch(setError({ neighborsProducts: false }));

    LocationService.getNeighborsProducts(action.payload)
        .then(data => store.dispatch(setNeighborsProducts(data.data)))
        .catch(err => store.dispatch(setError({ neighborsProducts: err })))
        .finally(() => {
            // Status zurücksetzen, sobald der Aufruf abgeschlossen ist (erfolgreich oder mit Fehler)
            isNeighborsProductsLoading = false;
            currentNeighborsProductsPayload = null;
        });
};

const getProductFilterHandler = (store: MainStore, action: ReturnType<typeof getDataFilter>): void => {
    store.dispatch(setLoader({ filter: true }));
    store.dispatch(setError({ filter: false }));

    LocationService.getProductFilter(action.payload)
        .then(data => store.dispatch(setDataFilter(data.data)))
        .then(() => store.dispatch(getDataFromUrlParams()))
        .catch(err => store.dispatch(setError({ filter: err })))
        .finally(() => store.dispatch(setLoader({ filter: false })));
};

const updateDataFilterHandler = (store: MainStore, action: ReturnType<typeof updateDataFilter>): void => {
    let out = {};
    const filter = action.payload;
    const {
        router: {
            location: { search },
        },
    } = store.getState();

    for (const key of Object.keys(filter) as Array<keyof DataSchemeFilter>) {
        if (filter[key] && !['bookingyear', 'basket', 'basketreference'].includes(key)) {
            const values = (filter[key] as FilterItemModel[]).filter(({ checked }) => checked).map(({ code }) => code);
            // Check if there are nested filters
            (filter[key] as FilterItemModel[]).map(filter => {
                if (filter.subnodes) {
                    filter.subnodes.map(sn => {
                        if (sn.checked) values.push(sn.code);

                        if (sn.subnodes) {
                            sn.subnodes.map(snn => {
                                if (snn.checked) values.push(snn.code);
                            });
                        }
                    });
                }
            });
            out = { ...out, [key]: values };
        }
    }
    const newSearchParams = updateQueryString(search, out);

    if (search.slice(1) !== newSearchParams) {
        store.dispatch(push({ search: updateQueryString(search, out) }));
    }
};

const getDataFromUrlParamsHandler = (store: MainStore): void => {
    const {
        location: { filter, coordinate },
        router: {
            location: { search },
        },
        collection: { collection },
    } = store.getState();
    const data = urlToFilters(search, { filter, coordinate, collection });
    const searchParams: queryString.ParsedQuery = queryString.parse(search, { arrayFormat: 'comma' });
    const bookingYear = searchParams['bookingyear'];
    if (bookingYear) {
        store.dispatch(setBookingYear(Number(bookingYear)));
    }

    store.dispatch(updateDataFilter(data.filter));
    store.dispatch(setCoordinateData(data.coordinate));
    store.dispatch(setCollection(data.collection as string[]));
    store.dispatch(getCollection(data.collection as string[]));
};

const resetDataFilterHandler = (store: MainStore): void =>
    void store.dispatch(updateDataFilter(resetFilterData(store.getState().location.filter)));

const updateCoordinateDataHandler = (store: MainStore, action: ReturnType<typeof updateCoordinateData>): void => {
    const {
        location: { coordinate },
        router: {
            location: { search },
        },
    } = store.getState();
    const { mode, radius } = coordinate;
    const coords = action.payload ?? { mode, radius, name: null, longitude: null, latitude: null, individualproduct: null };
    const coordsForState = action.payload ? { ...coordinate, ...action.payload } : { mode, radius };

    store.dispatch(push({ search: updateQueryString(search, coords as Record<string, string | number>) }));
    store.dispatch(setCoordinateData(coordsForState));
    store.dispatch(getProductList({ bookingyear: store.getState().location.bookingYear, reset: true }));
};

const getFactSheetHandler = (store: MainStore, action: ReturnType<typeof getFactSheet>): void => {
    store.dispatch(setLoader({ factSheet: true }));
    store.dispatch(setError({ factSheet: false }));
    const format = action.payload.format;
    if (format === 'pdf') {
        store.dispatch(setFactSheetPDF(''));
    } else if (format === 'xlsx') {
        store.dispatch(setFactSheetXLSX(''));
    } else if (format === 'ppt') {
        store.dispatch(setFactSheetPPT(''));
    }

    LocationService.getFactSheet(action.payload)
        .then(data => {
            const link = data.data.url;

            downloadFile(link);
            if (format === 'pdf') {
                store.dispatch(setFactSheetPDF(link));
            } else if (format === 'xlsx') {
                store.dispatch(setFactSheetXLSX(link));
            } else if (format === 'ppt') {
                store.dispatch(setFactSheetPPT(link));
            }
        })
        .catch(err => store.dispatch(setError({ factSheet: err })))
        .finally(() => store.dispatch(setLoader({ factSheet: false })));
};

const sendRequestHandler = (store: MainStore, action: ReturnType<typeof sendRequest>): void => {
    store.dispatch(setLoader({ request: true }));
    store.dispatch(setError({ request: false }));

    LocationService.sendRequest(action.payload)
        .then(() => store.dispatch(togglePopup({ name: 'location_request_success', status: true })))
        .catch(err => store.dispatch(setError({ request: err })))
        .finally(() => store.dispatch(setLoader({ request: false })));
};

const getCurrentPositionHandler = (store: MainStore): void => {
    const {
        ui: { loaders },
        location: { coordinate },
    } = store.getState();

    if (loaders.location) {
        return;
    }

    store.dispatch(setLoader({ searchNearMe: true }));

    navigator.geolocation.getCurrentPosition(
        ({ coords: { latitude, longitude } }: GeolocationPosition) => {
            store.dispatch(
                updateCoordinateData({
                    latitude,
                    longitude,
                    mode: CoordinateMode.Radius,
                    radius: coordinate.radius,
                    name: null as unknown as string,
                    individualproduct: null as unknown as string,
                })
            );
            store.dispatch(setLoader({ searchNearMe: false }));
        },
        ({ code, message }: GeolocationPositionError) => {
            store.dispatch(setError({ location: `Error geolocation [${code}]: ${message}` }));
            store.dispatch(setLoader({ searchNearMe: false }));
        },
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
    );
};

const getSmartPhrasesHandler = (store: MainStore): void => {
    LocationService.getSmartPhrases()
        .then(data => {
            store.dispatch(setSmartPhrases(data.data));
            store.dispatch(setSmartPhrasesList(data.data.map(item => item.phrase.toLowerCase() as string) as string[]));
        })
        .catch(err => store.dispatch(setError({ request: err })));
};

const abortSearch = (store: MainStore): void => {
    const { controller } = store.getState().location;
    if (controller) {
        controller.abort();
    }
    store.dispatch(createNewAbortController());
};

const setBookingYearHandler = (store: MainStore, action: ReturnType<typeof setBookingYear>): void => {
    const {
        router: {
            location: { search },
        },
    } = store.getState();
    const qs = { bookingyear: action.payload };
    store.dispatch(
        push({
            search: updateQueryString(search, qs as Record<string, string | string[] | number | undefined>),
        })
    );
};

const uploadSujetcheckImageHandler = (store: MainStore, action: ReturnType<typeof uploadSujetcheckImage>): void => {
    store.dispatch(setLoader({ sujetcheck: true }));
    store.dispatch(setError({ sujetcheck: false }));

    LocationService.postSujetcheckImage(action.payload)
        .then(data => {
            store.dispatch(setSujetcheckImageData(data.data as SujetCheckModel));
        })
        .catch(err => store.dispatch(setError({ sujetcheck: err })))
        .finally(() => store.dispatch(setLoader({ sujetcheck: false })));
};

const getSujetcheckImagesHandler = (store: MainStore, action: ReturnType<typeof getSujetcheckImages>): void => {
    store.dispatch(setLoader({ sujetcheck: true }));
    store.dispatch(setError({ sujetcheck: false }));

    LocationService.getSujetcheckImages(action.payload)
        .then(data => {
            store.dispatch(setSujetcheckImages(data as SetSujetCheckModel));
        })
        .catch(err => store.dispatch(setError({ sujetcheck: err })))
        .finally(() => store.dispatch(setLoader({ sujetcheck: false })));
};

const locationHandlers = {
    [RESET_DATA_FILTER]: resetDataFilterHandler,
    [UPDATE_DATA_FILTER]: updateDataFilterHandler,
    [GET_PRODUCT_LIST]: getProductListHandler,
    [GET_PRODUCT]: getProductHandler,
    [GET_PRODUCT_DETAILS]: getProductDetailsHandler,
    [GET_NEIGHBORS_PRODUCTS]: getNeighborsProductsHandler,
    [GET_DATA_FROM_URL_PARAMS]: getDataFromUrlParamsHandler,
    [UPDATE_COORDINATE_DATA]: updateCoordinateDataHandler,
    [GET_DATA_FILTER]: getProductFilterHandler,
    [GET_FACT_SHEET]: getFactSheetHandler,
    [SEND_REQUEST]: sendRequestHandler,
    [GET_CURRENT_POSITION]: getCurrentPositionHandler,
    [GET_SMART_PHRASES]: getSmartPhrasesHandler,
    [ABORT_SEARCH]: abortSearch,
    [SET_BOOKING_YEAR]: setBookingYearHandler,
    [UPLOAD_SUJETCHECK_IMAGE]: uploadSujetcheckImageHandler,
    [GET_SUJETCHECK_IMAGES]: getSujetcheckImagesHandler,
};

export default locationHandlers;
